export enum StatusEnum {
    NotSet,
    Success,
    Fail
}
